import { render, staticRenderFns } from "./OrderViewServices.vue?vue&type=template&id=b853eeaa&scoped=true&"
import script from "./OrderViewServices.vue?vue&type=script&lang=js&"
export * from "./OrderViewServices.vue?vue&type=script&lang=js&"
import style0 from "./OrderViewServices.vue?vue&type=style&index=0&id=b853eeaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b853eeaa",
  null
  
)

export default component.exports